import React, { useState } from 'react';
import Brand from '../components/Brand';
import { useAuth } from '../auth/AuthProvider';
import './AdminLogin.css';

function AdminLogin() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    const { error: signInError } = await signIn(email.trim(), password);

    if (signInError) {
      setError('Those details could not be verified. Please try again.');
      setSubmitting(false);
      return;
    }

    window.history.replaceState({}, '', '/admin/quotes');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <main className="auth-page">
      <div className="auth-card">
        <Brand />
        <div className="auth-intro">
          <span className="eyebrow">Private workspace</span>
          <h1>Welcome back</h1>
          <p>Sign in to manage Angus Ashton Film quotations.</p>
        </div>
        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="field">
            <span className="field__label">Email Address</span>
            <input
              autoComplete="email"
              onChange={(event) => setEmail(event.target.value)}
              required
              type="email"
              value={email}
            />
          </label>
          <label className="field">
            <span className="field__label">Password</span>
            <input
              autoComplete="current-password"
              onChange={(event) => setPassword(event.target.value)}
              required
              type="password"
              value={password}
            />
          </label>
          {error && (
            <p className="auth-error" role="alert">
              {error}
            </p>
          )}
          <button
            className="button button--accent auth-submit"
            disabled={submitting}
            type="submit"
          >
            {submitting ? 'SIGNING IN…' : 'SIGN IN'}
          </button>
        </form>
      </div>
    </main>
  );
}

export default AdminLogin;